<!--
@Author: Florian Merel <florian>
@Date:   26-Oct-2020
@Email:  florian.merel@prokov.com
@Project: ComEditServer
@Filename: App.vue
@Last modified by:   florian
@Last modified time: 09-Jul-2021
-->

<template>
  <v-app style="background-color: #eeeeee">
    <router-view></router-view>
    <SessionExpiredDialog v-model="showSessionExpiredDialog" />
  </v-app>
</template>

<script>
import SessionExpiredDialog from "@/components/SessionExpiredDialog.vue";
import {
  SESSION_EXPIRED_EVENT,
  ACCESS_BLOCKED_EVENT,
} from "@/plugins/axiosInterceptor";
import { startHeartbeat, stopHeartbeat } from "@/services/heartbeat";

export default {
  name: "App",
  components: {
    SessionExpiredDialog,
  },
  data() {
    return {
      showSessionExpiredDialog: false,
    };
  },
  mounted() {
    window.addEventListener(SESSION_EXPIRED_EVENT, this.handleSessionExpired);
    window.addEventListener(ACCESS_BLOCKED_EVENT, this.handleAccessBlocked);

    if (this.$route.path !== "/login") {
      startHeartbeat(this.handleSessionExpired);
    }
  },
  beforeDestroy() {
    window.removeEventListener(
      SESSION_EXPIRED_EVENT,
      this.handleSessionExpired,
    );
    window.removeEventListener(ACCESS_BLOCKED_EVENT, this.handleAccessBlocked);
    stopHeartbeat();
  },
  watch: {
    "$route.path"(newPath) {
      if (newPath === "/login") {
        stopHeartbeat();
      } else {
        const token = localStorage.getItem("token");
        if (token) {
          startHeartbeat(this.handleSessionExpired);
        }
      }
    },
  },
  methods: {
    handleSessionExpired() {
      stopHeartbeat();
      this.showSessionExpiredDialog = true;
    },

    // Requête bloquée en amont par nginx. Le token reste valide, seul le chemin réseau est fermé.
    handleAccessBlocked() {
      stopHeartbeat();

      if (this.$route.path !== "/login") {
        this.$router.push("/login").catch(() => {});
      }
    },
  },
};
</script>
